// professores-fotos.js
// Mapa nome do professor → arquivo da foto local (em public/img/professores/).
// Usado pelo frequencia-detail.js como fonte secundária: a primária é a URL
// vinda da planilha (campo `foto_url` em programacao), quando existir.
//
// Para adicionar/trocar uma foto:
//   1) coloque o arquivo em public/img/professores/<nome-slug>.png (ou .jpg)
//   2) acrescente a linha aqui usando o nome EXATO como aparece na planilha.
//
// Origem: extraído do v18 (App_Eloquence_v18_FREQ_COMPLETA.html, vars _I1.._I16).

export const PROFESSOR_FOTOS = {
  'Diego Wildberger':  'diego-wildberger.png',
  'Aline Nepomuceno':  'aline-nepomuceno.png',
  'Yang Mendes':       'yang-mendes.png',
  'Sandro Pinto':      'sandro-pinto.png',
  'Silvana Freire':    'silvana-freire.png',
  'Dayane Cavalheiro': 'dayane-cavalheiro.png',
  'Mirleide Sampaio':  'mirleide-sampaio.png',
  'Diogo Dantas':      'diogo-dantas.png',
  'Ulla von Czékus':   'ulla-von-czekus.png',
  'Bruno Freitas':     'bruno-freitas.png',
  'Luciano Conceição': 'luciano-conceicao.png',
  'Camilla Barros':    'camilla-barros.png',
  'Jefferson Beltrão': 'jefferson-beltrao.png',
  'Daniella Amaral':   'daniella-amaral.png',
  'Vitor Novaes':      'vitor-novaes.png',
};

// Normaliza nome para casar com o mapa mesmo com pequenas variações
// de caixa/acento ("Ulla Von Czékus" vs "Ulla von Czékus").
function _norm(s) {
  return String(s || '').trim().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const _INDEX = Object.create(null);
for (const [nome, file] of Object.entries(PROFESSOR_FOTOS)) {
  _INDEX[_norm(nome)] = file;
}

const BASE_PATH = './img/professores/';

/**
 * Retorna a URL da foto a ser usada para um professor.
 *
 * Prioridade:
 *   1) `urlPlanilha` (qualquer string http(s) não vazia) — vem do backend
 *      quando a planilha PROGRAMAÇÃO 2026 tiver o campo `foto_url`.
 *   2) Arquivo local mapeado pelo nome do professor.
 *   3) `null` — caller mostra fallback (iniciais).
 *
 * @param {string} nomeProfessor
 * @param {string} [urlPlanilha]
 * @returns {string|null}
 */
export function fotoProfessor(nomeProfessor, urlPlanilha) {
  if (urlPlanilha && /^https?:\/\//i.test(String(urlPlanilha).trim())) {
    return String(urlPlanilha).trim();
  }
  const file = _INDEX[_norm(nomeProfessor)];
  return file ? BASE_PATH + file : null;
}

/** Iniciais a partir do nome (fallback visual). */
export function inicaisProfessor(nome) {
  if (!nome) return '?';
  return String(nome).trim().split(/\s+/).slice(0, 2)
    .map(p => p[0] || '').join('').toUpperCase() || '?';
}
